import axios from "axios";
import { URI_LOCAL } from "../data/constants";

export const getAllErrors = () => {
    const response = axios.get(`${URI_LOCAL}TipoError/get_all_errors`)
    return response
}

export const saveError = (body:any) => {
    const response = axios.post(`${URI_LOCAL}TipoError/save_error`,body)
    return response
}

export const editError = (id:any,body:any) => {
    const response = axios.put(`${URI_LOCAL}TipoError/update_error/${id}`,body)
    return response
}

export const deleteError = (id:any) => {
    const response = axios.delete(`${URI_LOCAL}TipoError/delete_error/${id}`)
    return response
}